import UnitsTable from "./UnitsTableContainer";

export default UnitsTable;
